
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10px","height":"45px","viewBox":"0 0 10 45","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Path 11')]),_c('g',{attrs:{"id":"Layout","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Artikle_lvl_01_Boys_Nav_verhalten_03-Copy-3","transform":"translate(-1357.000000, -797.000000)","fill":"#1C0F0C","fill-rule":"nonzero"}},[_c('polygon',{attrs:{"id":"Path-11","transform":"translate(1362.000000, 819.250000) rotate(-180.000000) translate(-1362.000000, -819.250000) ","points":"1363 797 1363 830.5 1367 830.5 1362 841.5 1357 830.5 1361 830.5 1361 797"}})])])])
          )
        }
      }
    